export default [
    {
        path: '/entrance_guard',
        component: () => import('@/views/entranceGuard/entrance_guard.vue'),
    }
]